import React, { FC } from 'react';
import { ILayoutProps } from 'react-dropzone-uploader';

export const Layout: FC<ILayoutProps> = ({ input, dropzoneProps, files, previews }) => {
  return files.length ? <>{previews}</> : <div {...dropzoneProps}>{input}</div>;
};
